export const things = [
  { title: "Infecção sexualmente transmissível", link: "" },
  { title: "Tuberculose e doença por outras micobactérias", link: "" },
  { title: "Hepatite B", link: "" },
  { title: "Hepatite C", link: "" },
  { title: "Hepatite A", link: "" },
  { title: "Infecções Respiratórias", link: "" },
  { title: "Infecção Dos Ferimentos", link: "" },
  { title: "Gastroenterite", link: "" },
  { title: "Doenças Parasitárias", link: "" },
  { title: "Toxoplasmose", link: "" },
  { title: "Sífilis", link: "" },
  { title: "Gonorréia", link: "" },
  { title: "Clamídia", link: "" },
  { title: "Amigdalite", link: "" },
  { title: "HIV e AIDS", link: "" },
  { title: "Infecção Da Ferida Operatória", link: "" },
  { title: "Infecções Bacterianas", link: "" },
  { title: "Infecções Cardiovasculares", link: "" },
  { title: "Infecções Oportunistas", link: "" },
  { title: "Infecções Por Arbovirus", link: "" },
  { title: "Infecções por HTLV-I", link: "" },
  { title: "Infecções por HTLV-II", link: "" },
  { title: "Infecções Por Vírus Epstein-Barr", link: "" },
  { title: "Infecções Por Vírus Respiratório Sincicial", link: "" },
  { title: "Infecções relacionadas a prótese", link: "" },
  { title: "Influenza Humana", link: "" },
  { title: "Mononucleose Infecciosa: a doença do beijo", link: "" },
  { title: "Infecções urinárias de repetição", link: "" },
  { title: "Infecções pelo vírus herpes recorrente", link: "" },
  { title: "Infecção por micobactéria", link: "" },
  { title: "Infecção da garganta", link: "" },
  { title: "Infecção urinária", link: "" },
  { title: "Candidíase mucocutânea crônica", link: "" },
  { title: "Caxumba", link: "" },
  { title: "Chikungunya", link: "" },
  { title: "Coccidioidomicose", link: "" },
  { title: "Doença De Chagas", link: "" },
  { title: "Furunculose", link: "" },
  { title: "Giardíase", link: "" },
  { title: "Infecções Fúngicas Do Sistema Nervoso Central", link: "" },
  { title: "Infecções Por Helicobacter", link: "" },
  { title: "Infecções Por Pseudomonas", link: "" },
  { title: "Inflamação", link: "" },
  { title: "Leishmaniose", link: "" },
  { title: "Leptospirose", link: "" },
  { title: "Malária", link: "" },
  { title: "Meningite Criptocócica", link: "" },
  { title: "Monkeypox", link: "" },
  { title: "MRSA", link: "" },
  { title: "Nocardiose", link: "" },
  { title: "Pneumopatias Fúngicas", link: "" },
  { title: "Prevenção da malária", link: "" },
  { title: "Rubéola", link: "" },
  { title: "Sarampo", link: "" },
  { title: "Viroses", link: "" },
  { title: "Osteomielite", link: "" },
  { title: "Herpes zoster", link: "" },
  { title: "Cistite", link: "" },
];

export const opinions = [
  "Médico super acolhedor, pois quando estamos passando por momentos delicados que envolve a nossa saúde, tudo que queremos é ser acolhidos pelo profissional, e desde o início da consulta ele foi super humano, fiquei muito mais tranquila depois do atendimento. Ótimo profissional.",
  "Tive um ótimo atendimento! Dr. Gilberto foi atencioso, pontual e trouxe explicações claras!",
  "Começo de tratamento mas estou bem confiante, aparentemente um ótimo profissional.",
  "Super atencioso e tranquilo, explicou tudo com calma e clareza.",
  "Consulta marcada de ultima hora, mesmo assim tive toda a atenção possivel antes, durante e depois da consulta. Recomendo o dr. Gilberto.",
  "Profissional competente e humano, que demonstrou verdadeiro interesse pelo meu bem estar.",
  "Dr. Gilberto foi muito atencioso, explicativo, claro na conversa e objetivo.",
  "Excelente, Dr foi atencioso durante a consulta esclarecendo qualquer duvida.",
  "Muito bom atencioso,sabe explicar bem recomendo...",
  "Ótimo DR explica te orienta sobre tudo oque está com dúvidas muito bom.",
  "O Dr Gilberto me atendeu de última hora num momento de muita apreensão e com muito profissionalismo e explicações detalharas, mudou o rumo das coisas. Atento, solidário e muito, muito profissional!",
  "A consulta assim é muito prática, e já tira suas dúvidas",
  "O Dr. foi muito atencioso durante a consulta passando instruções personalizadas e atualizadas",
  "Atendimento excelente. Médico realizou todas as orientações necessários, foi educado, gentil e assertivo. Esclareceu todas as dúvidas e me deixou confiante quanto às medidas adotadas.",
  "Prestativo e objetivo, passando as informações necessárias.",
  "Acho que nunca me senti tão à vontade em uma consulta como me senti com o Drº Gilberto! Extremamente atencioso, gentil, humano, com uma empatia sem igual. Atualizado nos assuntos proporcionando o que há mais tecnológico para o tratamento. Me ajudou demais, me senti totalmente acolhido. Indico sem pensar em duas vezes. Parabéns, Dr Gilberto!!! E obrigado.",
  "O Dr. Gilberto demonstra uma clareza e didática impecáveis. Sua paciência e escuta ativa foram fundamentais para que eu me sentisse à vontade para expor todo o meu cenário. Com base nos fatos apresentados, ele ofereceu uma recomendação clara e assertiva. Recomendo fortemente a todos que buscam um infectologista de excelência.",
  "Ótimo profissional! Atencioso na consulta e claro nas explicações e ao sanar as dúvidas.",
  "Excelente atendimento e um ótimo rastreio da causa. Nota 10.",
  "O Dr. Gilberto é muito atencioso, educado, assertivo no diagnóstico e solícito para tirar dúvidas e acompanhar o caso. Excelente profissional.",
  "Ótimo tirou minhas dúvidas e acalmou minha cabeça pois estava muito preocupado !!!",
  "O que falar do Dr. Gilberto? Excelente profissional, dedicado, inteligente e atencioso desde da primeira consulta até agora, não tenho o que reclamar, só agradecer por tudo que tem feito por mim!! Recomendo o tanto que for preciso!! Está de parabéns mesmo!!",
  "Minha primeira consulta, gostei muito, foi bem atencioso.",
  "Médico sensacional. Sem palavras para agradecer seu profissionalismo e cuidado. Altamente atualizado, dedicado e assertivo. Obrigada por tudo!",
  "Excelente profissional! Atencioso e super atualizado.",
  "Dr Gilberto é um competente profissional e seus pacientes não poderiam estar em melhores mãos.",
  "Ótimo profissional! Recomendo muito! Prestou ótimo atendimento de infectologia para pacientes em uso de imunomoduladores como o meu caso.",
  "Ótimo especialista, tirou todas as minhas dúvidas, extremamente profissional!",
  "Medico excelente! Dá para ver que é atualizado, atencioso e explicou bem certinho o que eu precisava saber.",
  "Excelente profissional, competente, resolutivo e atencioso!",
  "Tratou do meu tio com muita atenção e muito resolutivo! Excelente médico!",
  "Dr Gilberto me atendeu de forma muito educada e explicou todas as minhas duvidas em relação a doença do meu pai. Tenho certeza que o tratamento vai dar muito certo!",
  "Muito atencioso, me passou muita confiança. Um excelente médico.",
  "muito gentil e simpático, foi direto ao ponto e o tratamento foi eficaz!",
  "Único médico que conseguiu ajudar meu pai depois de passarmos por muitos outros infectologistas. Recomendo!",
  "Dr Gilberto foi o melhor médico que já consultei. Atencioso, tranquilo e muito bem preparado, além de meu infectologista é meu clínico de referência.",
  "Dr Gilberto médico ímpar! Atencioso, claro em suas explicações, e baseado em evidências - tudo feito conforme a melhor medicina recomendada. Me ajudou muito.",
  "O recomendo como um infectologista excepcional. Sua expertise, empatia e consultas online acessíveis inspiram confiança e cuidado. Fiz uma ótima escolha!",
  "ótimo profissional, atencioso e muito eficiente!!!!!",
  "Cheguei ao senhor Gilberto por recomendação de amigos meus. Sempre que eu puder, estenderei essa recomendação. Atendimento humano e eficaz.",
  "Ótimo atendimento, pontual e com profissionalismo. Recomendo!",
];

export const googleReviews = [
  {
    name: "Pedro",
    comment:
      "Foi excelente  muito esclarecedora e com pontualidade britânica. Dr Gilberto demonstra conhecimento e sabe responder aos questionamentos com precisão. Agradeço sua atenção e recomendo sem qualquer ressalva",
  },
  {
    name: "Maria Heloise Girardi",
    comment:
      "Dr. Gilberto é um médico maravilhoso! Atencioso, paciente, e explica de forma esclarecedora demonstrando muito conhecimento.",
  },
  {
    name: "KAIO MATIAS",
    comment:
      "Atendimento excelente! Profissionalismo, empatia e cuidado em cada etapa do atendimento. Fui muito bem acolhido e tive todas as minhas dúvidas esclarecidas. Recomendo com confiança!",
  },
  {
    name: "Rodrigo da Silva",
    comment:
      "Agendamento rápido e ágil pela secretária. Atendimento do Dr. Gilberto foi pontual, na hora marcada.",
  },
  {
    name: "Joana Maria Coelho",
    comment:
      "Dr. Gilberto atendeu todas as minhas expectativas, soube esclarecer todas minhas dúvidas com firmeza e clareza.",
  },
  {
    name: "Gabryel Gustavo Faustino",
    comment:
      "Médico excelente. Atendimento impecável. Extremamente humano, ético, responsável.Precisávamos de mais médicos como Drº Gilberto no mundo. Indo de olhos fechados!!!",
  },
  {
    name: "Geovana Pereira",
    comment:
      "Excelente profissional. Esclareceu todas as dúvidas e indicou o melhor tratamento com muita propriedade e segurança.",
  },
  {
    name: "Eric Porto",
    comment:
      "Excelente profissional, atencioso, explicando e esclarecendo todas as minhas dúvidas.",
  },
];
